import { useBankProfile } from '@contexts/BankProfileContext';
import { Card, Typography } from '@gurupay/gp-ui-library';
import type { PersonalData } from '@hooks/usePersonalData';
import { RELATIONS_ROLES } from '@pages/settings/profile/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoRow } from './InfoRow';
import { RoleSection } from './RoleSection';

interface PersonalDetailsProps {
	isLoading: boolean;
	personalData?: PersonalData;
}

export const PersonalDetails: FC<PersonalDetailsProps> = ({
	personalData,
	isLoading,
}) => {
	const { t } = useTranslation('', { keyPrefix: 'profile' });
	const { isPersonal } = useBankProfile();

	return (
		<Card className="max-w-[512px]" title={t('privateTitle')}>
			<InfoRow
				isLoading={isLoading}
				label={t('name')}
				value={personalData?.customer_name}
			/>
			{(isPersonal || personalData?.email) && (
				<InfoRow isLoading={isLoading} label={t('email')} value={personalData?.email} />
			)}
			{(isPersonal || personalData?.phone_number) && (
				<InfoRow
					isLoading={isLoading}
					label={t('phone')}
					value={personalData?.phone_number}
				/>
			)}
			<InfoRow isLoading={isLoading} label={t('userId')} value={personalData?.username} />

			{!isPersonal && (
				<div>
					<Typography className="text-sm-medium mb-space-8 text-neutral-600">
						{t('assignmentsTitle')}
					</Typography>
					<div className="space-y-space-16">
						{RELATIONS_ROLES.map(({ key, title }) => {
							const assignment = personalData?.assignments[key];
							if (!assignment) {
								return null;
							}
							return (
								<RoleSection
									key={key}
									email={assignment?.email}
									isLoading={isLoading}
									phone={assignment?.phone_number}
									title={t(title)}
								/>
							);
						})}
					</div>
				</div>
			)}
		</Card>
	);
};
